<template>
  <div>
    <p class="extravehicle__footer">{{footerText}}</p>
  </div>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import {
  State, Getter, Action, Mutation, namespace
} from 'vuex-class';
import IVehicle from '@/models/vehicle/interfaces/vehicle.d';

const VehicleManagementModule = namespace('vehicleManagementModule');

@Component
export default class PresubXsaleFooterComponent extends Vue {
 @VehicleManagementModule.Getter public extraVehicles!: IVehicle[];

 public get footerText(): string {
   if (this.addedVehiclesCount < 1) {
     return 'You can continue without selecting a car';
   }

   return `(${this.addedVehiclesCount} out of 2) Vehicles selected`;
 }

 public get addedVehiclesCount(): number {
   return this.extraVehicles.length;
 }
}
</script>
